import type { JSX, ReactNode } from 'react';
import clsx from 'clsx';

interface FilterFieldProps {
  label: string;
  htmlFor?: string;
  children: ReactNode;
  className?: string;
}

/**
 * FilterField standardizes spacing + typography for dashboard filter controls.
 */
export function FilterField({
  label,
  htmlFor,
  children,
  className,
}: FilterFieldProps): JSX.Element {
  return (
    <div className={clsx('flex w-full flex-col gap-xs', className)}>
      <label
        htmlFor={htmlFor}
        className="text-xs font-semibold uppercase tracking-wide text-text-primary/60"
      >
        {label}
      </label>
      {children}
    </div>
  );
}
